/**
 * Format item counts into Stacks of 64 or other amounts.
 * @param {Number} input Counter input, single number
 * @param {Number} max Stack size, defaults to 64
 * @returns String of item count
 */
export function formatStack(input, max = 64) {
    let str = '';

    console.log(input, max, Math.floor(input / max), input % max)

    if (input > 64) {
        str += Math.floor(input / max) + ' Stk';

        if ((input % max) > 0) {
            str += ' + ';
            str += input % max;
        };
    } else {
        str = input;
    };

    return str;
};

export async function divide(arr, n = 2) {
    let nArr = [];
    for (let c = 0; c < n; c++) {
        nArr.push([]);
    };
    for (let i = 0; i < arr.length; i++) {
        let mod = i % n;
        nArr[mod].push(arr[i]);
    };
    return nArr;
}

import { db } from '../api.js';

export async function refresh(sect) {
    let api = {};
    db.subscribe(val => {
        api = val;
    });

    api[sect] = await fetch('https://api.phoenix-pages.izmichael.com/' + sect, {
        headers: {
            'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8'
        }
    }).then(res => {
        return res.json()
    });

    api.shops.sort((a, b) => (a.ShopName.toUpperCase() > b.ShopName.toUpperCase()) ? 1 : -1);
    api.places.sort((a, b) => (a.PlaceName.toUpperCase() > b.PlaceName.toUpperCase()) ? 1 : -1);
    api.paths.sort((a, b) => (a.PathName.toUpperCase() > b.PathName.toUpperCase()) ? 1 : -1);
    for (let i = 0; i < api.shops.length; i++) {
        api.shops[i].ShopProducts.sort((a, b) => (a.item.toUpperCase() > b.item.toUpperCase()) ? 1 : -1);
    };

    db.set(api);
};